function Myfooter() {
    return (<footer class="py-3 my-4">
    <p class="text-center text-muted">Donate: 0xa3c8Ef9BC502E02b9a5B4ffDc3ef94339ccC7d9C
    <br />&copy; 2023 BlockChain Johor By Mohd Aminurahim</p>
  </footer>
  );
}

export default Myfooter;